import { render, staticRenderFns } from "./buying-price.vue?vue&type=template&id=a63e91b0&scoped=true"
import script from "./buying-price.vue?vue&type=script&lang=js"
export * from "./buying-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63e91b0",
  null
  
)

export default component.exports